import { render, staticRenderFns } from "./addCompany.vue?vue&type=template&id=7353de1a&scoped=true"
import script from "./addCompany.vue?vue&type=script&lang=js"
export * from "./addCompany.vue?vue&type=script&lang=js"
import style0 from "./addCompany.vue?vue&type=style&index=0&id=7353de1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353de1a",
  null
  
)

export default component.exports